import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getGeneros = query =>
	fetch.get(
		`/generos${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getGenero = ({ id, query }) =>
	fetch.get(`/generos/${id}${
		query
			? `?${qs.stringify(
					{ ...query, publicationState: 'live' },
					{
						encodeValuesOnly: true,
					}
			  )}`
			: ''
	}
`);
export const addGenero = data => fetch.post('/generos', data);
export const updateGenero = ({ id, ...data }) =>
	fetch.put(`/generos/${id}`, data);
export const deleteGenero = id => fetch.delete(`/generos/${id}`);

// RTK Query
export const generosApi = createApi({
	reducerPath: 'generosApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getGeneros: build.query({
			query: query => {
				return {
					url: `/generos${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({ type: 'Generos', id })),
							{ type: 'Generos', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'Generos', id: 'LIST' }],
		}),
		getGenero: build.query({
			query: ({ id, query }) => {
				return {
					url: `/generos/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'Generos', id }],
		}),
		addGenero: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/generos`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Genero agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar genero');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'Generos', id: 'LIST' }],
		}),
		updateGenero: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/generos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Genero actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar genero');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [{ type: 'Generos', id }],
		}),
		deleteGenero: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/generos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Genero eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar genero');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'Generos', id }],
		}),
	}),
});

export const {
	useGetGenerosQuery,
	useGetGeneroQuery,
	useAddGeneroMutation,
	useUpdateGeneroMutation,
	useDeleteGeneroMutation,
} = generosApi;
